import {jsx, ParamComponent} from 'panel';
import rrwebPlayer from 'rrweb-player';

import {ModalEl, ModalType} from 'common/components/modal';
import {getProjectId} from 'common/report/util';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import './index.styl';

export interface RecordingPlayerJsxProps {
  params: {
    sessionId: string;
  };
  attrs: EmptyObj;
  props: EmptyObj;
  state: {
    distinctID: string;
  };
}

export class RecordingPlayer extends ParamComponent<RecordingPlayerJsxProps['params']> {
  get config() {
    return {
      params: {
        sessionId: {
          type: String,
          required: true,
        },
      },
      template: () => {
        return (
          <div sel='.recording-player'>
            <ModalEl
              attrs={{
                'modal-type': ModalType.Modal,
                open: true,
                closeable: true,
                'grow-to-content': true,
              }}
            >
              <div sel='.recording-content'>
                <div
                  sel='.player-target'
                  hook={{
                    insert: ({elm}) => this.showPlayer(this.params.sessionId, elm as HTMLElement),
                  }}
                />
              </div>
            </ModalEl>
          </div>
        );
      },
      defaultState: {
        distinctID: ``,
      },
    };
  }

  async showPlayer(sessionId: string, targetElm: HTMLElement) {
    const res = await fetch(`https://cdn-dev.mxpnl.com/srr/${getProjectId()}/${sessionId}/all.nljson`);
    const body = await res.text();
    const events = body
      .split(`\n`)
      .filter(Boolean)
      .map((line) => {
        try {
          return JSON.parse(line);
        } catch (err) {
          console.error(`failed to parse line`, line);
          return null;
        }
      })
      .filter(Boolean);
    new rrwebPlayer({
      target: targetElm,
      props: {
        autoPlay: false,
        events,
        height: 400,
        width: 800,
      },
    });
  }
}

export const RecordingPlayerEl = defineAndMakeJsxFactory<RecordingPlayerJsxProps>(
  `mp-recording-player`,
  RecordingPlayer,
);
export const RecordingPlayerReact = panel2react<RecordingPlayerJsxProps>(`mp-recording-player`, RecordingPlayer);
